import React from 'react';
import {
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  Avatar
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // eslint-disable-line no-unused-vars
import WorkIcon from '@mui/icons-material/Work';
import PeopleIcon from '@mui/icons-material/People';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FoundationIcon from '@mui/icons-material/Foundation';
import arunOjhaPhoto from '../../assets/images/Arun Ojha.png';
import PremiumHeader from '../../components/Header/PremiumHeader';
import { useLang, t } from '../../context/LanguageContext';
import T from '../../translations/index';
import '../common.css';
import './aboutus.css';
import Footer from '../../components/Footer/Footer';

const AboutUs = () => {
  const navigate = useNavigate();
  const { lang } = useLang();

  // eslint-disable-next-line no-unused-vars
  const handleNavClick = (e, path) => {
    e.preventDefault();
    
    switch (path) {
      case 'home':
        navigate('/');
        break;
      case 'about':
        navigate('/about');
        break;
      case 'services':
        navigate('/services');
        break;
      case 'projects':
        navigate('/projects');
        break;
      case 'clients':
        navigate('/clients');
        break;
      case 'careers':
        navigate('/careers');
        break;
      case 'hireus':
        navigate('/hireus');
        break;
      case 'contact':
        navigate('/contact');
        break;
      default:
        break;
    }
  };



  const companyOverview = t(T.companyOverviewText, lang);

  const vision = t(T.visionText, lang);

  const mission = t(T.missionText, lang);

  const keyServices = lang === 'hi' ? [
    'यांत्रिक औद्योगिक संविदा',
    'क्षेत्र विकास और बागवानी कार्य',
    'सभी प्रकार के यांत्रिक कार्य',
    'परियोजना नियोजन और पर्यवेक्षण',
    'खरीद और आपूर्ति प्रबंधन',
    'कार्यबल और साइट प्रबंधन',
    'सुरक्षा और अनुपालन निगरानी',
    'भारी उपकरण संचालन और किराया'
  ] : [
    'Mechanical Industrial Contracting',
    'Area Development & Horticulture Works',
    'All Kinds of Mechanical Works',
    'Project Planning & Supervision',
    'Procurement & Supply Management',
    'Workforce & Site Management',
    'Safety & Compliance Monitoring',
    'Heavy Equipment Operation & Rental'
  ];

  const achievements = lang === 'hi' ? [
    'भारत में बिजली और सीमेंट क्षेत्रों में 50+ प्रमुख परियोजनाएं पूर्ण की हैं।',
    'NTPC, Adani, Vedanta, Tata Power और Ambuja Cement सहित शीर्ष ग्राहकों के विश्वसनीय साझेदार।',
    'गुणवत्ता, समय पर डिलीवरी और सुरक्षा मानकों के अनुपालन के लिए पहचाने गए।',
    'Power Mech, Simplex Infrastructure और Simar Infrastructure जैसे प्रमुख EPC ठेकेदारों के साथ सिद्ध ट्रैक रिकॉर्ड।'
  ] : [
    'Executed 50+ major projects across India in Power & Cement sectors.',
    'Trusted partner of top clients including NTPC, Adani, Vedanta, Tata Power, and Ambuja Cement.',
    'Recognized for quality, timely delivery, and compliance with safety standards.',
    'Proven track record with leading EPC contractors like Power Mech, Simplex Infrastructure, and Simar Infrastructure.'
  ];

  const leadership = [
    { 
      name: 'Arun Ojha', 
      designation: t(T.leadershipDirector, lang), 
      profile: t(T.leadershipProfile, lang),
      photo: arunOjhaPhoto
    }
  ];

  const subdiaries = [
    { name: t(T.sub1Name, lang), designation: t(T.sub1Desig, lang), profile: t(T.sub1Profile, lang) },
    { name: t(T.sub2Name, lang), designation: t(T.sub2Desig, lang), profile: t(T.sub2Profile, lang) },
    { name: t(T.sub3Name, lang), designation: t(T.sub3Desig, lang), profile: t(T.sub3Profile, lang) }
  ];

  const clients = lang === 'hi' ? [
    'तोशिबा पावर (TPSC) - अनूपर, म.प्र.',
    'लैंको इन्फ्राटेक लि. - कोरबा, छ.ग.',
    'वेदांता एल्यूमीनियम और पावर - झारसुगुड़ा, ओडिशा',
    'अडाणी पावर लि. - गुजरात और झारखंड',
    'मैथन पावर लि. - झारखंड',
    'CLP इंडिया प्रा. लि. - हरियाणा',
    'KSK महानदी पावर - अकलतरा, छ.ग.',
    'अंबुजा सीमेंट - भाटापारा, छ.ग.',
    'BHEL - सागरदिघी, प.बं.',
    'NTPC (तांडवा, बक्सर, NKSTPP)',
    'टाटा पावर - जमशेदपुर, झारखंड',
    'STEAG एनर्जी सर्विसेज (इंडिया) प्रा. लि. - झारसुगुड़ा, ओडिशा'
  ] : [
    'Toshiba Power (TPSC) - Anuppur, M.P.',
    'Lanco Infratech Ltd. - Korba, C.G.',
    'Vedanta Aluminium & Power - Jharsuguda, Odisha',
    'Adani Power Ltd. - Gujarat & Jharkhand',
    'Maithon Power Ltd. - Jharkhand',
    'CLP India Pvt. Ltd. - Haryana',
    'KSK Mahanadi Power - Akaltara, C.G.',
    'Ambuja Cement - Bhatapara, C.G.',
    'BHEL - Sagardighi, W.B.',
    'NTPC (Tandwa, Buxar, NKSTPP)',
    'Tata Power - Jamshedpur, Jharkhand',
    'STEAG Energy Services (India) Pvt. Ltd. - Jharsuguda, Odisha'
  ];

  return (
    <div className="about-page">
      <PremiumHeader />

      {/* ── Hero Banner ── */}
      <section className="about-hero-banner">
        <div className="about-hero-bg" />
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <div className="about-hero-eyebrow">Est. 2010 · Jamshedpur, Jharkhand</div>
          <h1 className="about-hero-title">
            {t(T.aboutPageTitle, lang)}<br/>
            <span>Trishivanay Construction Pvt. Ltd.</span>
          </h1>
          <p className="about-hero-desc">
            {t(T.aboutPageSubtitle, lang)}
          </p>
          <div className="about-hero-badges">
            <span className="about-hero-badge"><span>🏅</span> DPIIT Recognised Startup</span>
            <span className="about-hero-badge"><span>🔬</span> MSME Certified</span>
            <span className="about-hero-badge"><span>⚡</span> 50+ Projects Delivered</span>
            <span className="about-hero-badge"><span>🗺️</span> Pan-India Operations</span>
          </div>
        </div>
      </section>

      {/* ── Stats Bar ── */}
      <div className="about-stats-bar">
        <div className="about-stats-inner">
          {[
            { num: '14+', label: 'Years of Experience' },
            { num: '50+', label: 'Projects Delivered' },
            { num: '15+', label: 'Marquee Clients' },
            { num: '500+', label: 'Skilled Workforce' },
            { num: '8+', label: 'States Covered' },
          ].map((s, i) => (
            <div className="about-stat-item" key={i}>
              <div className="about-stat-num">{s.num}</div>
              <div className="about-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Certifications Strip ── */}
      <div className="about-cert-strip">
        <div className="about-cert-strip-inner">
          <div className="about-cert-badge"><span>🏅</span> DPIIT Recognised Startup (Dept. for Promotion of Industry &amp; Internal Trade)</div>
          <div className="about-cert-badge"><span>🏭</span> MSME Certified Enterprise</div>
          <div className="about-cert-badge"><span>✅</span> IBR-Compliant Welding Works</div>
          <div className="about-cert-badge"><span>🛡️</span> ISO-Aligned Quality &amp; Safety</div>
        </div>
      </div>

      {/* ── Main Content ── */}
      <div className="about-content">

        {/* Company Story */}
        <section className="about-story-section">
          <div className="about-story-grid">
            <div className="about-story-text">
              <div className="about-section-eyebrow">Our Story</div>
              <h2 className="about-section-title">India's Trusted Thermal Power Mechanical Contractor</h2>
              <p className="about-story-body">{companyOverview}</p>
              <p className="about-story-body" style={{marginTop:'-8px'}}>
                {t(T.operatingThrough, lang)} <strong>Ananya Engineering</strong>, <strong>Ojha Constructions</strong>, and <strong>Shiv Shakti Enterprises</strong> — we provide complete mechanical contracting from detailed engineering to final commissioning, with a proven 14+ year track record across India's most demanding industrial sites.
              </p>
              <div className="about-story-highlights">
                {[
                  { icon: '⚡', title: 'Thermal Power', desc: 'Specialist in coal-based thermal power plant construction, 210MW to 800MW' },
                  { icon: '🔬', title: 'IBR Certified', desc: 'All pressure piping by IBR-certified welders with full NDT compliance' },
                  { icon: '🛡️', title: 'Zero Compromise Safety', desc: 'Dedicated HSE team on every project, full OSHA/IS code compliance' },
                  { icon: '📍', title: 'Pan-India', desc: 'Active in 8+ states: Jharkhand, Odisha, Chhattisgarh, Gujarat & more' },
                ].map((h, i) => (
                  <div className="about-story-highlight" key={i}>
                    <span className="about-story-highlight-icon">{h.icon}</span>
                    <div className="about-story-highlight-text">
                      <strong>{h.title}</strong>{h.desc}
                    </div>
                  </div>
                ))}
              </div>
              <div className="about-explore-row" style={{marginTop:'28px'}}>
                <button className="about-explore-btn primary" onClick={() => navigate('/services')}>🔧 Our Services</button>
                <button className="about-explore-btn secondary" onClick={() => navigate('/clients')}>🏢 Our Clients</button>
              </div>
            </div>
            <div className="about-story-image">
              <img src="https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?auto=format&fit=crop&w=800&q=80" alt="Industrial construction work" loading="lazy" />
            </div>
          </div>
        </section>

        {/* Vision Mission Values */}
        <section className="about-vmv-section">
          <div style={{textAlign:'center', marginBottom:'8px'}}>
            <div className="about-section-eyebrow">What Drives Us</div>
            <h2 className="about-section-title">Vision · Mission · Values</h2>
          </div>
          <div className="about-vmv-grid">
            <div className="about-vmv-card vision">
              <span className="about-vmv-icon">🔭</span>
              <div className="about-vmv-title">{t(T.cardVision, lang)}</div>
              <p className="about-vmv-text">{vision}</p>
            </div>
            <div className="about-vmv-card mission">
              <span className="about-vmv-icon">🎯</span>
              <div className="about-vmv-title">{t(T.cardMission, lang)}</div>
              <p className="about-vmv-text">{mission}</p>
            </div>
            <div className="about-vmv-card values">
              <span className="about-vmv-icon">💎</span>
              <div className="about-vmv-title">Our Core Values</div>
              <p className="about-vmv-text">Safety First · Quality Excellence · On-Time Delivery · Technical Innovation · Client Satisfaction · Workforce Welfare · Environmental Responsibility</p>
            </div>
          </div>
        </section>

        {/* Key Services Grid */}
        <section className="about-services-section">
          <div style={{textAlign:'center', marginBottom:'8px'}}>
            <div className="about-section-eyebrow">What We Do</div>
            <h2 className="about-section-title">{t(T.cardKeyServices, lang)}</h2>
          </div>
          <div className="about-services-grid">
            {[
              { icon: '🔥', name: 'Boiler Works', desc: 'Drum, header, panel fabrication, erection & pressure testing' },
              { icon: '🌀', name: 'ESP Systems', desc: 'Electrostatic precipitator erection, alignment & commissioning' },
              { icon: '⚙️', name: 'Coal Handling', desc: 'Conveyor systems, crushers, feeders & coal yard machinery' },
              { icon: '💨', name: 'Ash Management', desc: 'ESP hoppers, fly ash systems, bottom ash systems & slurry' },
              { icon: '🌡️', name: 'Cooling Tower', desc: 'Cooling tower civil, mechanical & structural works' },
              { icon: '🏗️', name: 'Chimney Works', desc: 'Flue gas ducts, dampers & chimney erection works' },
              { icon: '🌿', name: 'FGD Systems', desc: 'Flue gas desulfurization for emission compliance' },
              { icon: '🛠️', name: 'Shutdown/AMC', desc: 'Annual maintenance & emergency shutdown contracts' },
            ].map((s, i) => (
              <div className="about-service-card" key={i}>
                <span className="about-service-icon">{s.icon}</span>
                <div className="about-service-name">{s.name}</div>
                <div className="about-service-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Leadership */}
        <section className="about-leadership-section">
          <div className="about-section-eyebrow">Leadership</div>
          <h2 className="about-section-title">{t(T.cardLeadership, lang)}</h2>
          <div className="about-leadership-card" style={{marginTop:'28px'}}>
            <img src={arunOjhaPhoto} alt="Arun Ojha" className="about-leadership-photo" />
            <div className="about-leadership-info">
              <div className="about-leadership-name">Arun Ojha</div>
              <div className="about-leadership-role">{t(T.leadershipDirector, lang)}</div>
              <p className="about-leadership-bio">{t(T.leadershipProfile, lang)}</p>
              <div className="about-leadership-achievements">
                {[
                  { num: '14+', label: 'Years Experience' },
                  { num: '50+', label: 'Projects Led' },
                  { num: '500+', label: 'Team Members' },
                  { num: '15+', label: 'Major Clients' },
                ].map((a, i) => (
                  <div className="about-leadership-ach" key={i}>
                    <div className="about-leadership-ach-num">{a.num}</div>
                    <div className="about-leadership-ach-label">{a.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Group Companies */}
        <section className="about-subs-section">
          <div className="about-section-eyebrow">Our Group</div>
          <h2 className="about-section-title">{t(T.cardSubsidiaries, lang)}</h2>
          <div className="about-subs-grid" style={{marginTop:'28px'}}>
            {subdiaries.map((sub, i) => (
              <div className="about-sub-card" key={i}>
                <span className="about-sub-icon">{['🏗️','⚙️','🔩'][i]}</span>
                <div className="about-sub-name">{sub.name}</div>
                <div className="about-sub-role">{sub.designation}</div>
                <p className="about-sub-desc">{sub.profile}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Clients */}
        <section className="about-clients-section">
          <div className="about-section-eyebrow">Our Clients</div>
          <h2 className="about-section-title">{t(T.cardEsteemedClients, lang)}</h2>
          <div className="about-clients-list" style={{marginTop:'24px'}}>
            {clients.map((c, i) => (
              <div className="about-client-chip" key={i}>{c}</div>
            ))}
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );



};

export default AboutUs;
